module.exports = __webpack_public_path__ + "img/card_header_help_content.9579e48d.jpg";